export const LocalKey = {
  AUTH: "AUTH",
  BOOKING_APPOINTMENT: "BOOKING_APPOINTMENT",
  LANGUAGE: "LANGUAGE",
};
